import type { GameType, InMode, OutMode, TeamPlayMode } from "@shared/index";

export const GAME_LABELS: Record<GameType, string> = {
  x01: "x01",
  cricket: "Cricket",
  elimination: "Elimination",
  clock: "Around the Clock",
  shanghai: "Shanghai",
  highscore: "Highscore",
};

export const GAME_BLURBS: Record<GameType, string> = {
  x01: "Klassiker: 301 bis 901, Double-In/Out, Master-Out.",
  cricket: "15–20 + Bull. Extra-Marks nach Wahl: Normal, CutThroat oder ohne Punkte.",
  elimination: "Von 0 hochzählen bis x01. Gleicher Score setzt den Gegner auf 0.",
  clock: "1 bis 20, dann Bull. Bei jedem Segment: Doppel überspringt eine Zahl, Triple zwei. Nur Doubles/Triples ohne Überspringen.",
  shanghai: "Immer die nächste Zahl (1–20, dann Bull). S+D+T in einer Aufnahme gewinnt sofort.",
  highscore: "Highscore Punkte in 7 Runden",
};

export function boardNumberLabel(n: number | undefined | null): string {
  if (n == null) return "–";
  if (n === 25 || n >= 21) return "Bull";
  return String(n);
}

export const IN_LABELS: Record<InMode, string> = {
  straight: "Straight In",
  double: "Double In",
};

export const OUT_LABELS: Record<OutMode, string> = {
  straight: "Straight Out",
  double: "Double Out",
  master: "Master Out",
};

export function marksGlyph(count: number): string {
  if (count <= 0) return "";
  if (count === 1) return "/";
  if (count === 2) return "X";
  return "⊗";
}

export const CRICKET_SCORING_LABELS: Record<"normal" | "cutThroat" | "noScore", string> = {
  normal: "Normal",
  cutThroat: "CutThroat",
  noScore: "No Score",
};

export const TEAM_PLAY_LABELS: Record<TeamPlayMode, string> = {
  solo: "Einzel",
  league: "Liga-Team",
  team: "Team",
};

export const TEAM_PLAY_BLURBS: Record<TeamPlayMode, string> = {
  solo: "",
  league: "Doppel auf einer Bahn/Score, 2-4 Teams möglich",
  team: "Jeder Spieler hat seinen eigenen Score. Ausmachen gesperrt wenn der Partner mehr Punkte hat als ein anderes Team gemeinsam",
};

export const CRICKET_TEAM_PLAY_BLURBS: Record<TeamPlayMode, string> = {
  solo: "",
  league: "Doppel auf einer Bahn/Score, 2-4 Teams möglich",
  team: "Punkte erst wenn beide Teamkollegen die Zahl geschlossen haben",
};

export function cricketGameLabel(scoring?: "normal" | "cutThroat" | "noScore"): string {
  if (!scoring || scoring === "normal") return "Cricket";
  return `Cricket · ${CRICKET_SCORING_LABELS[scoring]}`;
}
